import * as React from 'react';
import { withEditorContext } from '../Editor';
function Separator(context) {
    return (React.createElement("span", { style: context.styles.separator }));
}
var WrappedSeparator = withEditorContext(Separator);
export default WrappedSeparator;
//# sourceMappingURL=Separator.js.map